/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminTeamsResponse,
  AssignProjectRequest,
  CreateTeamRequest,
  CreateTeamResponse,
  DeleteTeamParams,
  GetFreeAgentsParams,
  GetFreeAgentsResponse,
  GetNewMemberParams,
  GetTeamDetailsParams,
  GetTeamDetailsResponse,
  GetTeamIdsParams,
  GetTeamIdsResponse,
  GetTeamMembersParams,
  GetTeamMembersResponse,
  GetTeamsCountsParams,
  GetTeamsCountsResponse,
  GetTeamsParams,
  HTTPValidationError,
  NewMemberResponse,
  ProposeTeamsRequest,
  UnassignProjectRequest,
  UpdateTeamAssignmentRequest,
  UpdateTeamMembersRequest,
} from './platformapi.schemas';

import getTeamsMutator from '../custom-axios-instance';
import approveTeamMutator from '../custom-axios-instance';
import assignTeamToProjectMutator from '../custom-axios-instance';
import getTeamsCountsMutator from '../custom-axios-instance';
import createTeamMutator from '../custom-axios-instance';
import deleteTeamMutator from '../custom-axios-instance';
import getTeamDetailsMutator from '../custom-axios-instance';
import getFreeAgentsMutator from '../custom-axios-instance';
import getTeamIdsMutator from '../custom-axios-instance';
import getTeamMembersMutator from '../custom-axios-instance';
import getNewMemberMutator from '../custom-axios-instance';
import proposeCohortTeamsMutator from '../custom-axios-instance';
import unassignTeamFromProjectMutator from '../custom-axios-instance';
import updateTeamAssignmentMutator from '../custom-axios-instance';
import updateTeamMembersMutator from '../custom-axios-instance';

/**
 * Returns teams and related data for a given cohort.
 * @summary Get Teams
 */
export const getTeams = (params: GetTeamsParams, signal?: AbortSignal) => {
  return getTeamsMutator<AdminTeamsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamsQueryKey = (params?: GetTeamsParams) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/teams/`, ...(params ? [params] : [])] as const;
};

export const getGetTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeams>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeams>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeams>>> = ({ signal }) =>
    getTeams(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeams>>>;
export type GetTeamsQueryError = void | HTTPValidationError;

export function useGetTeams<
  TData = Awaited<ReturnType<typeof getTeams>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeams>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeams>>,
          TError,
          Awaited<ReturnType<typeof getTeams>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeams<
  TData = Awaited<ReturnType<typeof getTeams>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeams>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeams>>,
          TError,
          Awaited<ReturnType<typeof getTeams>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeams<
  TData = Awaited<ReturnType<typeof getTeams>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeams>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Teams
 */

export function useGetTeams<
  TData = Awaited<ReturnType<typeof getTeams>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeams>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates all user team assignments for a given team to approved status.
 * @summary Approve Team
 */
export const approveTeam = (approveTeamBody: number[], signal?: AbortSignal) => {
  return approveTeamMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/approve-teams`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: approveTeamBody,
    signal,
  });
};

export const getApproveTeamMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveTeam>>,
    TError,
    { data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveTeam>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationKey = ['approveTeam'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveTeam>>,
    { data: number[] }
  > = (props) => {
    const { data } = props ?? {};

    return approveTeam(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveTeamMutationResult = NonNullable<Awaited<ReturnType<typeof approveTeam>>>;
export type ApproveTeamMutationBody = number[];
export type ApproveTeamMutationError = void | HTTPValidationError;

/**
 * @summary Approve Team
 */
export const useApproveTeam = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveTeam>>,
      TError,
      { data: number[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveTeam>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationOptions = getApproveTeamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Assigns a team to a project by creating a TeamAssignment.
 * @summary Assign Team To Project
 */
export const assignTeamToProject = (
  assignProjectRequest: AssignProjectRequest,
  signal?: AbortSignal,
) => {
  return assignTeamToProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/assign-project`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: assignProjectRequest,
    signal,
  });
};

export const getAssignTeamToProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTeamToProject>>,
    TError,
    { data: AssignProjectRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignTeamToProject>>,
  TError,
  { data: AssignProjectRequest },
  TContext
> => {
  const mutationKey = ['assignTeamToProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignTeamToProject>>,
    { data: AssignProjectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignTeamToProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignTeamToProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignTeamToProject>>
>;
export type AssignTeamToProjectMutationBody = AssignProjectRequest;
export type AssignTeamToProjectMutationError = void | HTTPValidationError;

/**
 * @summary Assign Team To Project
 */
export const useAssignTeamToProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignTeamToProject>>,
      TError,
      { data: AssignProjectRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignTeamToProject>>,
  TError,
  { data: AssignProjectRequest },
  TContext
> => {
  const mutationOptions = getAssignTeamToProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get counts of teams and free agents for a given cohort. Supports tab items counts in admin teams view.
 * @summary Get Teams Counts
 */
export const getTeamsCounts = (params: GetTeamsCountsParams, signal?: AbortSignal) => {
  return getTeamsCountsMutator<GetTeamsCountsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/counts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamsCountsQueryKey = (params?: GetTeamsCountsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/counts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamsCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamsCounts>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamsCounts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamsCountsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamsCounts>>> = ({ signal }) =>
    getTeamsCounts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamsCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamsCounts>>>;
export type GetTeamsCountsQueryError = void | HTTPValidationError;

export function useGetTeamsCounts<
  TData = Awaited<ReturnType<typeof getTeamsCounts>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsCountsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamsCounts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamsCounts>>,
          TError,
          Awaited<ReturnType<typeof getTeamsCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamsCounts<
  TData = Awaited<ReturnType<typeof getTeamsCounts>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamsCounts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamsCounts>>,
          TError,
          Awaited<ReturnType<typeof getTeamsCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamsCounts<
  TData = Awaited<ReturnType<typeof getTeamsCounts>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamsCounts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Teams Counts
 */

export function useGetTeamsCounts<
  TData = Awaited<ReturnType<typeof getTeamsCounts>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamsCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamsCounts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamsCountsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new team with given member IDs in proposed status.
 * @summary Create Team
 */
export const createTeam = (createTeamRequest: CreateTeamRequest, signal?: AbortSignal) => {
  return createTeamMutator<CreateTeamResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createTeamRequest,
    signal,
  });
};

export const getCreateTeamMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeam>>,
    TError,
    { data: CreateTeamRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { data: CreateTeamRequest },
  TContext
> => {
  const mutationKey = ['createTeam'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeam>>,
    { data: CreateTeamRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createTeam(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>;
export type CreateTeamMutationBody = CreateTeamRequest;
export type CreateTeamMutationError = void | HTTPValidationError;

/**
 * @summary Create Team
 */
export const useCreateTeam = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTeam>>,
      TError,
      { data: CreateTeamRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { data: CreateTeamRequest },
  TContext
> => {
  const mutationOptions = getCreateTeamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a team and all associated user team assignments.
 * @summary Delete Team
 */
export const deleteTeam = (params: DeleteTeamParams, signal?: AbortSignal) => {
  return deleteTeamMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/delete`,
    method: 'POST',
    params,
    signal,
  });
};

export const getDeleteTeamMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeam>>,
    TError,
    { params: DeleteTeamParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeam>>,
  TError,
  { params: DeleteTeamParams },
  TContext
> => {
  const mutationKey = ['deleteTeam'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeam>>,
    { params: DeleteTeamParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteTeam(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>;

export type DeleteTeamMutationError = void | HTTPValidationError;

/**
 * @summary Delete Team
 */
export const useDeleteTeam = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTeam>>,
      TError,
      { params: DeleteTeamParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeam>>,
  TError,
  { params: DeleteTeamParams },
  TContext
> => {
  const mutationOptions = getDeleteTeamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get detailed info for a given team.
 * @summary Get Team Details
 */
export const getTeamDetails = (params: GetTeamDetailsParams, signal?: AbortSignal) => {
  return getTeamDetailsMutator<GetTeamDetailsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/details`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamDetailsQueryKey = (params?: GetTeamDetailsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamDetails>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamDetails>>> = ({ signal }) =>
    getTeamDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamDetails>>>;
export type GetTeamDetailsQueryError = void | HTTPValidationError;

export function useGetTeamDetails<
  TData = Awaited<ReturnType<typeof getTeamDetails>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamDetailsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamDetails>>,
          TError,
          Awaited<ReturnType<typeof getTeamDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamDetails<
  TData = Awaited<ReturnType<typeof getTeamDetails>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamDetails>>,
          TError,
          Awaited<ReturnType<typeof getTeamDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamDetails<
  TData = Awaited<ReturnType<typeof getTeamDetails>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamDetails>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Team Details
 */

export function useGetTeamDetails<
  TData = Awaited<ReturnType<typeof getTeamDetails>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamDetails>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get free agents for a given cohort. Free agents are users eligible to be assigned to teams but were not done so via auto or manual creation.
 * @summary Get Free Agents
 */
export const getFreeAgents = (params: GetFreeAgentsParams, signal?: AbortSignal) => {
  return getFreeAgentsMutator<GetFreeAgentsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/free-agents`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetFreeAgentsQueryKey = (params?: GetFreeAgentsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/free-agents`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFreeAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFreeAgents>>,
  TError = void | HTTPValidationError,
>(
  params: GetFreeAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeAgents>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFreeAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreeAgents>>> = ({ signal }) =>
    getFreeAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFreeAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFreeAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof getFreeAgents>>>;
export type GetFreeAgentsQueryError = void | HTTPValidationError;

export function useGetFreeAgents<
  TData = Awaited<ReturnType<typeof getFreeAgents>>,
  TError = void | HTTPValidationError,
>(
  params: GetFreeAgentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreeAgents>>,
          TError,
          Awaited<ReturnType<typeof getFreeAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFreeAgents<
  TData = Awaited<ReturnType<typeof getFreeAgents>>,
  TError = void | HTTPValidationError,
>(
  params: GetFreeAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreeAgents>>,
          TError,
          Awaited<ReturnType<typeof getFreeAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFreeAgents<
  TData = Awaited<ReturnType<typeof getFreeAgents>>,
  TError = void | HTTPValidationError,
>(
  params: GetFreeAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeAgents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Free Agents
 */

export function useGetFreeAgents<
  TData = Awaited<ReturnType<typeof getFreeAgents>>,
  TError = void | HTTPValidationError,
>(
  params: GetFreeAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeAgents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFreeAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Team Ids
 */
export const getTeamIds = (params: GetTeamIdsParams, signal?: AbortSignal) => {
  return getTeamIdsMutator<GetTeamIdsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/ids`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamIdsQueryKey = (params?: GetTeamIdsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/ids`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamIds>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamIds>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamIdsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamIds>>> = ({ signal }) =>
    getTeamIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamIds>>>;
export type GetTeamIdsQueryError = void | HTTPValidationError;

export function useGetTeamIds<
  TData = Awaited<ReturnType<typeof getTeamIds>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamIdsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamIds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamIds>>,
          TError,
          Awaited<ReturnType<typeof getTeamIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamIds<
  TData = Awaited<ReturnType<typeof getTeamIds>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamIds>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamIds>>,
          TError,
          Awaited<ReturnType<typeof getTeamIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamIds<
  TData = Awaited<ReturnType<typeof getTeamIds>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamIds>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Team Ids
 */

export function useGetTeamIds<
  TData = Awaited<ReturnType<typeof getTeamIds>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamIds>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamIdsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets team members for a given team.
 * @summary Get Team Members
 */
export const getTeamMembers = (params: GetTeamMembersParams, signal?: AbortSignal) => {
  return getTeamMembersMutator<GetTeamMembersResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/members`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamMembersQueryKey = (params?: GetTeamMembersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/members`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamMembersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMembers>>> = ({ signal }) =>
    getTeamMembers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamMembers>>>;
export type GetTeamMembersQueryError = void | HTTPValidationError;

export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamMembersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getTeamMembers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getTeamMembers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Team Members
 */

export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = void | HTTPValidationError,
>(
  params: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamMembersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get one user to add to team via admin modal
 * @summary Get New Member
 */
export const getNewMember = (params: GetNewMemberParams, signal?: AbortSignal) => {
  return getNewMemberMutator<NewMemberResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/new-member`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetNewMemberQueryKey = (params?: GetNewMemberParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/teams/new-member`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetNewMemberQueryOptions = <
  TData = Awaited<ReturnType<typeof getNewMember>>,
  TError = void | HTTPValidationError,
>(
  params: GetNewMemberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewMember>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNewMemberQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewMember>>> = ({ signal }) =>
    getNewMember(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNewMember>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNewMemberQueryResult = NonNullable<Awaited<ReturnType<typeof getNewMember>>>;
export type GetNewMemberQueryError = void | HTTPValidationError;

export function useGetNewMember<
  TData = Awaited<ReturnType<typeof getNewMember>>,
  TError = void | HTTPValidationError,
>(
  params: GetNewMemberParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewMember>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewMember>>,
          TError,
          Awaited<ReturnType<typeof getNewMember>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNewMember<
  TData = Awaited<ReturnType<typeof getNewMember>>,
  TError = void | HTTPValidationError,
>(
  params: GetNewMemberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewMember>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewMember>>,
          TError,
          Awaited<ReturnType<typeof getNewMember>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNewMember<
  TData = Awaited<ReturnType<typeof getNewMember>>,
  TError = void | HTTPValidationError,
>(
  params: GetNewMemberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewMember>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get New Member
 */

export function useGetNewMember<
  TData = Awaited<ReturnType<typeof getNewMember>>,
  TError = void | HTTPValidationError,
>(
  params: GetNewMemberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewMember>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNewMemberQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Propose Cohort Teams
 */
export const proposeCohortTeams = (
  proposeTeamsRequest: ProposeTeamsRequest,
  signal?: AbortSignal,
) => {
  return proposeCohortTeamsMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/propose-cohort-teams`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: proposeTeamsRequest,
    signal,
  });
};

export const getProposeCohortTeamsMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeCohortTeams>>,
    TError,
    { data: ProposeTeamsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proposeCohortTeams>>,
  TError,
  { data: ProposeTeamsRequest },
  TContext
> => {
  const mutationKey = ['proposeCohortTeams'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proposeCohortTeams>>,
    { data: ProposeTeamsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return proposeCohortTeams(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProposeCohortTeamsMutationResult = NonNullable<
  Awaited<ReturnType<typeof proposeCohortTeams>>
>;
export type ProposeCohortTeamsMutationBody = ProposeTeamsRequest;
export type ProposeCohortTeamsMutationError = void | HTTPValidationError;

/**
 * @summary Propose Cohort Teams
 */
export const useProposeCohortTeams = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof proposeCohortTeams>>,
      TError,
      { data: ProposeTeamsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof proposeCohortTeams>>,
  TError,
  { data: ProposeTeamsRequest },
  TContext
> => {
  const mutationOptions = getProposeCohortTeamsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unassigns a team from a project by deleting the TeamAssignment and cancels any scheduled assignment emails for all users.
 * @summary Unassign Team From Project
 */
export const unassignTeamFromProject = (
  unassignProjectRequest: UnassignProjectRequest,
  signal?: AbortSignal,
) => {
  return unassignTeamFromProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/unassign-project`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unassignProjectRequest,
    signal,
  });
};

export const getUnassignTeamFromProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unassignTeamFromProject>>,
    TError,
    { data: UnassignProjectRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unassignTeamFromProject>>,
  TError,
  { data: UnassignProjectRequest },
  TContext
> => {
  const mutationKey = ['unassignTeamFromProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unassignTeamFromProject>>,
    { data: UnassignProjectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return unassignTeamFromProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnassignTeamFromProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof unassignTeamFromProject>>
>;
export type UnassignTeamFromProjectMutationBody = UnassignProjectRequest;
export type UnassignTeamFromProjectMutationError = void | HTTPValidationError;

/**
 * @summary Unassign Team From Project
 */
export const useUnassignTeamFromProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unassignTeamFromProject>>,
      TError,
      { data: UnassignProjectRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unassignTeamFromProject>>,
  TError,
  { data: UnassignProjectRequest },
  TContext
> => {
  const mutationOptions = getUnassignTeamFromProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates the organization decision for a team's project assignment.
 * @summary Update Team Assignment
 */
export const updateTeamAssignment = (
  updateTeamAssignmentRequest: UpdateTeamAssignmentRequest,
  signal?: AbortSignal,
) => {
  return updateTeamAssignmentMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/update-assignment`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateTeamAssignmentRequest,
    signal,
  });
};

export const getUpdateTeamAssignmentMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamAssignment>>,
    TError,
    { data: UpdateTeamAssignmentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamAssignment>>,
  TError,
  { data: UpdateTeamAssignmentRequest },
  TContext
> => {
  const mutationKey = ['updateTeamAssignment'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamAssignment>>,
    { data: UpdateTeamAssignmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateTeamAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeamAssignment>>
>;
export type UpdateTeamAssignmentMutationBody = UpdateTeamAssignmentRequest;
export type UpdateTeamAssignmentMutationError = void | HTTPValidationError;

/**
 * @summary Update Team Assignment
 */
export const useUpdateTeamAssignment = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTeamAssignment>>,
      TError,
      { data: UpdateTeamAssignmentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamAssignment>>,
  TError,
  { data: UpdateTeamAssignmentRequest },
  TContext
> => {
  const mutationOptions = getUpdateTeamAssignmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates team members for a given team. Refreshes all team_assignment scheduled notifications by cancelling, updating existing team members, then re-scheduling. For reps this is essentially a no-op.
 * @summary Update Team Members
 */
export const updateTeamMembers = (
  updateTeamMembersRequest: UpdateTeamMembersRequest,
  signal?: AbortSignal,
) => {
  return updateTeamMembersMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/teams/update-members`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateTeamMembersRequest,
    signal,
  });
};

export const getUpdateTeamMembersMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamMembers>>,
    TError,
    { data: UpdateTeamMembersRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamMembers>>,
  TError,
  { data: UpdateTeamMembersRequest },
  TContext
> => {
  const mutationKey = ['updateTeamMembers'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamMembers>>,
    { data: UpdateTeamMembersRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateTeamMembers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeamMembers>>
>;
export type UpdateTeamMembersMutationBody = UpdateTeamMembersRequest;
export type UpdateTeamMembersMutationError = void | HTTPValidationError;

/**
 * @summary Update Team Members
 */
export const useUpdateTeamMembers = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTeamMembers>>,
      TError,
      { data: UpdateTeamMembersRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamMembers>>,
  TError,
  { data: UpdateTeamMembersRequest },
  TContext
> => {
  const mutationOptions = getUpdateTeamMembersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
